import { IApplicationState } from '../../types/redux';
import { dealTypeFromJsonQuery } from '../category';

export const selectDealType = (state: IApplicationState) => {
  return dealTypeFromJsonQuery(state.filters.jsonQuery);
};
